var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGitlab(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 551.379 512",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M113.329 7.188c-3.338-9.584-16.906-9.584-20.352 0l-60.84 188.228h142.14c-.108 0-60.948-188.228-60.948-188.228zM1.017 290.176c-2.8 8.614.323 18.198 7.645 23.69L275.605 512 32.029 195.416l-31.012 94.76zm173.152-94.76L275.713 512l101.544-316.584zm376.24 94.76l-31.012-94.76L275.713 512l266.943-198.134c7.43-5.492 10.445-15.076 7.753-23.69zM458.449 7.188c-3.338-9.584-16.906-9.584-20.352 0l-60.948 188.228h142.14z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGitlab);
export default ForwardRef;